import React from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import AlertDialog from "./AlertDialog";
import { JoinedAlert } from "../../../types";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

import "./index.css";

const { Title, Text } = Typography;

type Props = {
  loading: boolean;
  isFetchingMore: boolean;
  joinedAlerts: JoinedAlert[];
  onScroll: React.UIEventHandler<HTMLDivElement>;
};

const MaintenanceAlert: React.FC<Props> = ({
  loading,
  isFetchingMore,
  joinedAlerts,
  onScroll,
}) => {
  return (
    <div className="detection-box-container">
      <Spin spinning={loading}>
        <div className="detection-box-title">
          <Title level={4} className="detection-box-title-text ">
            Trap maintenance
          </Title>
        </div>
        <div
          className={`detection-box-alerts force-show-scrollbars max-h-150! overflow-y-scroll ${
            joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
          }`}
          onScroll={onScroll}
        >
          {joinedAlerts.length > 0 ? (
            <>
              {joinedAlerts.map((item: JoinedAlert) => (
                <AlertDialog key={item._id} item={item} />
              ))}
              {isFetchingMore && (
                <div className="flex justify-center p-4">
                  <Spin size="small" />
                </div>
              )}
            </>
          ) : (
            <AlertAntd
              message={<Text strong>No maintenance alerts</Text>}
              showIcon
              type="success"
              icon={<CheckCircleIcon className="w-6 h-6 text-[#22C55E]" />}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export { MaintenanceAlert };
